import { useState } from "react";
import type { PriceRow } from "@/mocks/priceTables";
import PriceRowTable from "./PriceRowTable";

/** 絞り込みのお悩み（既存タグのみ。新しいカテゴリは追加しない） */
export const SKIN_CONCERNS = ["すべて", "ニキビ", "シミ・くすみ", "たるみ・シワ", "毛穴"];

/**
 * お肌管理タブ用の簡易フィルターのバー。
 * 「悩み」で施術を絞り込み、その場で表示だけを切り替える（ページ遷移なし）。
 * 4分類の見出しを保ったまま全グループをまとめて絞り込むため、単体でも利用する。
 */
export function SkinConcernFilterBar({
  active,
  onChange,
}: {
  active: string;
  onChange: (concern: string) => void;
}) {
  return (
    <div
      className="flex flex-nowrap gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:flex-wrap md:overflow-visible md:pb-0"
      role="tablist"
      aria-label="お悩みで絞り込む"
    >
      {SKIN_CONCERNS.map((concern) => {
        const selected = active === concern;
        return (
          <button
            key={concern}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(concern)}
            className={`cursor-pointer whitespace-nowrap rounded-sm border px-3 py-1.5 text-[12px] leading-none transition-colors ${
              selected
                ? "border-foreground-950 bg-foreground-950 text-background-50"
                : "border-foreground-950/15 bg-background-50 text-foreground-700 hover:bg-background-100"
            }`}
          >
            {concern}
          </button>
        );
      })}
    </div>
  );
}

/** 指定したお悩みで行を絞り込む（「すべて」はそのまま） */
export function filterBySkinConcern(rows: PriceRow[], concern: string): PriceRow[] {
  return concern === "すべて" ? rows : rows.filter((row) => row.tags?.includes(concern));
}

/** 単一グループ用（後方互換）。フィルターと表をまとめて表示する。 */
export default function SkinConcernFilter({ rows }: { rows: PriceRow[] }) {
  const [active, setActive] = useState<string>("すべて");
  return (
    <div>
      <SkinConcernFilterBar active={active} onChange={setActive} />
      <PriceRowTable rows={filterBySkinConcern(rows, active)} />
    </div>
  );
}